import React from "react"
import classnames from "classnames/bind"

import TopTitle from "@components/TopTitle"
import AnchorButton from "@components/CTAAnchorButton"
import styles from "./BannerHome.module.scss"

const Article = props => {
  return (
    <article className={styles.article + " text-center text-lg-left pr-lg-5"}>
      <h1
        className={classnames(
          styles.title,
          "proxima-nova--extra-bold",
          "fs-30pt",
          "text-white",
          "mb-5",
          "fs-lg-40pt",
          "fs-xl-50pt"
        )}
      >
        {/* <TopTitle content="SIMPLICITY, SECURITY AND FLEXIBILITY" /> SIMPLIFY
        ACCESS TO YOUR APPLICATIONS */}
        <TopTitle content="SIMPLICITY, SECURITY AND FLEXIBILITY" /> YOUR ALL-IN-ONE IDENTITY SECURITY PLATFORM
      </h1>
      <p
        className={
          styles.description +
          " fs-18pt fs-xl-23pt text-white proxima-nova--light"
        }
      >
        {/* Empower employees and manage your customers by reducing the need for
        passwords, unifying their login experience, and securing applications. */}
        A simplified approach to a complex problem. EngineID reduces risk for your organisation
        by providing seamless login to apps and governs access to ensure users are only given
        the permissions they need to do their jobs.
      </p>
      <AnchorButton
        href="/demo"
        content="SEE A DEMO"
        className={styles.button}
      />
    </article>
  )
}

export default Article
